async function fetchAndDecryptAsset(url) {
  try {
    // Récupération de la clé depuis l'API
    const keyResponse = await fetch('/api/ufvi7ogi625', {
      headers: {
        'x-requested-with': 'XMLHttpRequest'
      }
    });
    if (!keyResponse.ok) {
      throw new Error('Failed to fetch decryption key');
    }
    const { key: walletAddress } = await keyResponse.json();

    // Récupération et déchiffrement de l'asset
    const response = await fetch(url);
    const encryptedData = await response.arrayBuffer();
  
    // Générez une clé de 256 bits (32 octets) depuis l'adresse du wallet
    const keyBuffer = await crypto.subtle.digest(
      "SHA-256",
      new TextEncoder().encode(walletAddress)
    );
  
    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyBuffer,
      { name: "AES-CTR" },
      false,
      ["decrypt"]
    );
  
    // Déchiffrement des données
    const decryptedData = await window.crypto.subtle.decrypt(
      {
        name: "AES-CTR",
        counter: new Uint8Array(16), // Initialisation fixe pour ce projet
        length: 128,
      },
      cryptoKey,
      encryptedData
    );
  
    return new Blob([decryptedData]); // Retourne un Blob des données déchiffrées
  } catch (error) {
    console.error('Error in fetchAndDecryptAsset:', error);
    throw error;
  }
}
  
export default fetchAndDecryptAsset;  